import { createFileRoute, redirect } from '@tanstack/react-router';
import { getTenantAuthStorage, getAdminAuthStorage } from '@/utils/authStorage';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const tenantStorage = getTenantAuthStorage();
    const adminStorage = getAdminAuthStorage();
    if (tenantStorage.getUser() && tenantStorage.getToken()) {
      // replace: true → 히스토리에 '/' 남기지 않음. 뒤로가기 시 /로 돌아와 로그인으로 튕기는 현상 방지
      throw redirect({ to: '/entry', replace: true });
    }
    if (adminStorage.getUser() && adminStorage.getToken()) {
      throw redirect({ to: '/admin', replace: true });
    }
    throw redirect({ to: '/login' });
  },
});
